import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@material-ui/core/styles';
import { AppBar, Tabs, Tab, Box, Badge } from '@material-ui/core';

import AgendamentoConfirmacao from '../childrens/agendamentoConfirmado/.mixins';
import TodosPedidos from '../childrens/todosPedidos/.mixins';
import AgendamentoPendentes from '../childrens/agendamentoPendentes/.mixins';
import AgendamentoRecusados from '../childrens/agendamentoRecusados/.mixins';
import ProtocoloAgendamento from '../childrens/protocoloAgendamento/.mixins';
import EntregasConcluídas from '../childrens/entregaConcluidas/.mixins';
import { PendingProductsReturn } from '../childrens/retiradasPendentes/.mixins';
import { useTotalPendingReturnProductsGql } from '../childrens/retiradasPendentes/.mixins/graphql/totalPendingProductReturn';
import Cookies from 'universal-cookie';

//css
import TabsCss from './styles';
import { AuthContext } from '../../../../../../../../contexts/AuthContext';
const useStyles = TabsCss();

const TabPanel = (props) => {
  const { children, value, index, marginBox, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={!isNaN(parseInt(marginBox)) ? marginBox : 3}>
          {children}
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
};

const LabelTab = ({ numberNotifications, title }) => {
  return (
    <>
      <Badge badgeContent={numberNotifications} color="error" overlap='rectangular'>
        {title}
      </Badge>
    </>
  );
};

export default (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [disableTab, setDisableTab] = useState(true)
  const { user } = useContext(AuthContext);

  const cookies = new Cookies();
  const userCode = cookies.get('User-Code');

  const {
    runTotalPendingReturnProductsGql,
    dataTotalPendingReturnProducts,
  } = useTotalPendingReturnProductsGql();

  const handleOnTabClick = () => {
    if (disableTab) {
      props.childAlerta.current.retorno('Selecione o fornecedor', 'warning');
    }
  }

  useEffect(() => {
    if (user.isVisaoTok && props.state.fornecedor === +userCode || props.state.fornecedor === null) {
      setDisableTab(true)
    }

    if (user.isVisaoTok && props.state.fornecedor !== +userCode && props.state.fornecedor > 0) {
      setDisableTab(false)
    }

    if (!user.isVisaoTok && props.state.fornecedor === +userCode) {
      setDisableTab(false)
    }

    if(props.state.fornecedor > 0){
      runTotalPendingReturnProductsGql({
        variables: {
          personId: props.state.fornecedor,
          initialRow: 0,
          nextRows: 1
        }
      });
    }
  }, [props.state.fornecedor])

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          onClick={handleOnTabClick}
          value={props.state.valueTab}
          onChange={props.handlerChangeTab}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          aria-label="full width tabs example"
        >
          {user.permissions["gerenciar-pedidos.todos-pedidos"] &&
            <Tab
              disabled={disableTab}
              label={
                <LabelTab
                  numberNotifications={0}
                  title="Todos pedidos"
                />
              }
              value={0}
              {...a11yProps(0)}
            />
          }

          {user.permissions["gerenciar-pedidos.pendentes"] &&
            <Tab
              disabled={disableTab}
              label={
                <LabelTab
                  numberNotifications={props.state.qtdAgendamentoPendentes}
                  title="Confirmação pendente"
                />
              }
              value={1}
              {...a11yProps(1)}
            />
          }

          {user.permissions["gerenciar-pedidos.confirmados"] &&
            <Tab
              disabled={disableTab}
              label={
                <LabelTab
                  numberNotifications={0}
                  title="Agendamentos confirmados"
                />
              }
              value={2}
              {...a11yProps(2)}
            />
          }

          {user.permissions["gerenciar-pedidos.recusados"] &&
            <Tab
              disabled={disableTab}
              label={
                <LabelTab
                  numberNotifications={0}
                  title="Agendamentos recusados"
                />
              }
              value={3}
              {...a11yProps(3)}
            />
          }

          {user.permissions["gerenciar-pedidos.protocolo-agendamento"] &&
            <Tab
              disabled={disableTab}
              label={
                <LabelTab
                  numberNotifications={0}
                  title="Protocolo de agendamento"
                />
              }
              value={4}
              {...a11yProps(4)}
            />
          }

          {user.permissions["gerenciar-pedidos.entregas-concluidas"] &&
            <Tab
              disabled={disableTab}
              label={
                <LabelTab
                  numberNotifications={0}
                  title="Entregas concluídas"
                />
              }
              value={5}
              {...a11yProps(5)}
            />
          }

          {user.permissions["gerenciar-pedidos.retiradas-pendentes"] &&
            <Tab
              disabled={disableTab}
              label={
                <LabelTab
                  numberNotifications={dataTotalPendingReturnProducts.totalRows}
                  title="Retiradas pendentes"
                />
              }
              value={6}
              {...a11yProps(6)}
            />
          }
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={props.state.valueTab}
        onChangeIndex={props.handlerChangeIndex}
      >
        {user.permissions["gerenciar-pedidos.todos-pedidos"] &&
          <TabPanel value={props.state.valueTab} index={0} dir={theme.direction}>
            <TodosPedidos {...props} />
          </TabPanel>
        }

        {user.permissions["gerenciar-pedidos.pendentes"] &&
          <TabPanel value={props.state.valueTab} index={1} dir={theme.direction}>
            <AgendamentoPendentes {...props} />
          </TabPanel>
        }

        {user.permissions["gerenciar-pedidos.confirmados"] &&
          <TabPanel value={props.state.valueTab} index={2} dir={theme.direction}>
            <AgendamentoConfirmacao {...props} />
          </TabPanel>
        }

        {user.permissions["gerenciar-pedidos.recusados"] &&
          <TabPanel value={props.state.valueTab} index={3} dir={theme.direction}>
            <AgendamentoRecusados {...props} />
          </TabPanel>
        }

        {user.permissions["gerenciar-pedidos.protocolo-agendamento"] &&
          <TabPanel marginBox={0} value={props.state.valueTab} index={4} dir={theme.direction}>
            <ProtocoloAgendamento {...props} />
          </TabPanel>
        }

        {user.permissions["gerenciar-pedidos.entregas-concluidas"] &&
          <TabPanel value={props.state.valueTab} index={5} dir={theme.direction}>
            <EntregasConcluídas {...props} />
          </TabPanel>
        }

        {user.permissions["gerenciar-pedidos.retiradas-pendentes"] &&
          <TabPanel value={props.state.valueTab} index={6} dir={theme.direction}>
            <PendingProductsReturn {...props} />
          </TabPanel>
        }
      </SwipeableViews>
    </div>
  );
};
